// extracted by mini-css-extract-plugin
module.exports = {"exit":"tutorialModal_exit__mZHmn","tutorial":"tutorialModal_tutorial__3cHLL"};